"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { useState, useEffect } from "react";

import { api, RouterOutputs } from "~/utils/api";
import EditProfileModal from "~/components/profile-components/EditProfileModal";
import { Button } from "~/components/v3/themed/Button";
import { FollowUserButton } from "~/components/v4/themed/user/FollowUserButton";
import { CreateEventButton } from "~/app/beta/home/_components/CreateEventModal";
import { CommunitiesToHostOption } from "~/app/beta/events/create/actions";
import UserSubscriptionStatus from "~/components/profile-components/UserSubscriptionStatus";

const ProfileOptions = ({
    user,
    isCurrentUser,
    communities,
}: {
    user: RouterOutputs["user"]["getProfile"];
    isCurrentUser: boolean;
    communities?: CommunitiesToHostOption[];
}) => {
    // Todo: remove this so it'll all be server actions
    const apiCtx = api.useUtils();
    const router = useRouter();
    const searchParams = useSearchParams();

    const [showEditProfileModal, setShowEditProfileModal] = useState(false);

    const { data: isFollowing, isLoading } =
        api.followers.isUserFollowing.useQuery({
            followedUserId: user.id,
        });

    useEffect(() => {
        const editMode = searchParams?.get("editMode");
        if (editMode === "true") setShowEditProfileModal(true);
    }, [searchParams]);

    if (!isCurrentUser)
        return (
            <section>
                <div className="flex flex-row flex-wrap gap-2">
                    <div className="flex flex-row gap-2">
                        <FollowUserButton
                            userId={user.id}
                            isFollowing={isFollowing ?? false}
                            isLoading={isLoading}
                        />
                    </div>
                </div>
            </section>
        );

    return (
        <section>
            <div className="flex flex-row flex-wrap gap-2">
                <div className="flex flex-row gap-2">
                    <Button
                        className="w-[130px] "
                        variant="secondary"
                        onClick={() => setShowEditProfileModal(true)}
                    >
                        Edit Profile
                    </Button>
                    <CreateEventButton user={user} communities={communities} />
                    <UserSubscriptionStatus />
                </div>
            </div>
            <EditProfileModal
                isVisible={showEditProfileModal}
                setVisible={(e) => {
                    setShowEditProfileModal(e);
                    apiCtx.user.getProfile.invalidate();
                    apiCtx.user.getProfile.refetch();
                    router.refresh();
                }}
            />
        </section>
    );
};

export default ProfileOptions;
